<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="title"
        :primaryAction="{
            label: $t.__('common.actions.close'),
            action: () => (showModal = false),
        }"
        @closed="$emit('close')"
    >
        <div class="typographies-paragraph-medium-regular" v-html="message" />
    </CompassModal>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
    },
    emits: ['close'],
    data() {
        return {
            showModal: true,
        };
    },
};
</script>
